import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlSegmentGroup, UrlTree } from '@angular/router';
import { Observable, catchError, filter, map, of } from 'rxjs';
import { AutenticacaoService } from './autenticacao.service';
import { PlatformLocation } from '@angular/common';
import { ToastService } from '../libs/toast/toast.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AutorizacaoAlertaService {

  constructor(private toast: ToastService) { }

  public showNoAuthentication(): void {
    this.toast.showWarning('Ops, usuário não autenticado.');
  }

  public showNoPermissionArea(): void {
    this.toast.showNoPermission('Desculpe, sem permissão para acessar este recurso.');
  }

  public showNoPermissionAction(): void {
    this.toast.showNoPermission('Desculpe, sem permissão para executar esta operação.');
  }
}

@Injectable({
  providedIn: 'root'
})
export class AutorizacaoGuardAsync implements CanActivate, CanActivateChild, CanLoad
{
  extrarirCd: boolean = true;

  constructor(
    public authService: AutenticacaoService, 
    private alert: AutorizacaoAlertaService,
    private router: Router, 
    private autenticacao: AutenticacaoService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {  
    // Se permissions não informado, então permite.
    //if(!route.data.permissions && !route.data.permissionsAny)
     //return true;
     console.log(">>>>>>>can active ? " +  window.location.pathname);
     console.log(route);
     console.log(state);

     if(this.extrarirCd) {
      this.extrarirCd = false;

      const tree: UrlTree = this.router.parseUrl(state.url);
      tree.queryParams = [];

      return tree;
    } 

    let permissions: any[] =
      Array.isArray(route.data['permissions']) ? route.data['permissions'] : [];

    let permissionsAny: any[] =
      Array.isArray(route.data['permissionsAny']) ? route.data['permissionsAny'] : [];

    return this.isAllowed(state.url, permissions.length >= permissionsAny.length ? permissions : permissionsAny, 
      permissions.length >= permissionsAny.length ? false : true);
  } 
  
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    console.log(">>>>>>>can active child" +  window.location.pathname);
    return true;
  }
  
  /*
    Se o usuário está autenticado, então permite o carregamento do módulo.
  */
  canLoad(route: Route, segments: UrlSegment[]):  Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    console.log(">>>>>>>can load   ? " + window.location.pathname);

    return this.autenticacao
    .inicializacaoStatus
    .pipe(
      filter((x) => x === true), 
      map((e) => {
        if(this.extrarirCd) {
          this.extrarirCd = false;

          let g = new UrlSegmentGroup(segments, {});

          let tree = new UrlTree();
          tree.root = g;
          tree.queryParams = [];
          
          return tree;
        } 

        return true;
      })
    ); 
  }

  isAllowed(url: string, permissions: string[] = [], any: boolean = false): Observable<boolean | UrlTree> {
    return this.autenticacao.possuiPermissoes(permissions, any).pipe(
      map(
        (x) => {
          let routerx: Router = this.router;

          if(!x.result) {
            this.alert.showNoPermissionArea();

            if(this.router?.getCurrentNavigation()?.previousNavigation == null)
              return routerx.createUrlTree(['/']);
            else {
              return false;
            }
          }

          return x.result;
        }
      ),
      catchError((err: HttpErrorResponse) => { 

        if(err.status == 401) {
          this.autenticacao.executarRedirecionamento();
        } 

        return of(false);
      })
    );
  }
}
